<template>
	<div class="modal-overlay">
		<div class="modal">
			<h3>{{ $t("panels.sendToHelpdesk.title") }}</h3>
			<p>
				{{ $t("panels.sendToHelpdesk.introText") }}
			</p>
			<p>
				{{ $t("panels.sendToHelpdesk.notificationText") }}
			</p>
			<p>
				{{ $t("panels.sendToHelpdesk.lockNotice") }}
			</p>
			<form @submit.prevent="sendToHelpdesk">
				<div style="display: flex; flex-direction: column">
					<label for="email"
						>{{ $t("panels.sendToHelpdesk.emailLabel") }}</label
					>
					<input
						id="email"
						v-model="emailAddress"
						type="email"
						:placeholder="$t('panels.sendToHelpdesk.emailPlaceholder')"
						required
					/>
					<p v-if="emailError" class="input-error-message">{{ emailError }}</p>
				</div>

				<div style="display: flex; flex-direction: row-reverse; gap: 8px; margin-top: 12px">
					<button type="submit" class="blexon-button">{{ $t("panels.sendToHelpdesk.submitButton") }}</button>
					<button @click="$emit('close')">{{ $t("panels.sendToHelpdesk.cancelButton") }}</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script setup>
import { LoadingState } from "@/model/Enums";
import { BlexonErpApi } from "@/store/BlexonErpApi";
import { useMainStore } from "@/store/mainStore";
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const store = useMainStore();
const emailAddress = ref(store.article.defaultEMail);
const emailError = ref("");

const emit = defineEmits(["close", "sendToHelpdesk"]);

const validateEmail = () => {
	if (!emailAddress.value) {
		emailError.value = t("panels.sendToHelpdesk.emailRequiredError");
		return false;
	}
	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	if (!emailPattern.test(emailAddress.value)) {
		emailError.value = t("panels.sendToHelpdesk.emailInvalidError");
		return false;
	}
	emailError.value = "";
	return true;
};

const sendToHelpdesk = () => {
	if (validateEmail()) {
		BlexonErpApi.sendArticleToHelpdeskByToken(store.token, emailAddress.value);
		emit("sendToHelpdesk");
	}
};
</script>
